class SmidCatalogueFaq extends HTMLElement {
  connectedCallback() {
    const fallback = this.querySelector('[data-description-fallback]');
    const source = fallback?.querySelector('[data-description]');
    if (!source) return;
    const headings = source.querySelectorAll(':scope > h2, :scope > h3');
    if (!headings.length) return;
    const fragment = document.createDocumentFragment();
    let body;
    const createDisclosure = title => {
      const details = document.createElement('details');
      details.className = 'sc-faq';
      const summary = document.createElement('summary');
      summary.textContent = title;
      const icon = document.createElement('span');
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '+';
      summary.append(icon);
      body = document.createElement('div');
      body.className = 'sc-faq__body rte';
      details.append(summary, body);
      fragment.append(details);
      return summary;
    };
    // Move the original nodes so text, links and formatting are preserved.
    for (const node of [...source.childNodes]) {
      if (node instanceof HTMLElement && /^(H2|H3)$/.test(node.tagName)) {
        const summary = createDisclosure(node.textContent);
        if (node.id) summary.id = node.id;
      } else if (node.textContent.trim() || node instanceof HTMLElement) {
        if (!body) createDisclosure(fallback.querySelector('summary').childNodes[0].textContent);
        body.append(node);
      }
    }
    if (fragment.childElementCount) fallback.replaceWith(fragment);
  }
}

class SmidCatalogueMore extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.addEventListener('click', event => this.load(event), { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
  async load(event) {
    const link = event.target.closest('a[data-next-page]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (this.busy) return;
    const results = this.closest('results-list'), grid = results?.querySelector('.product-grid');
    if (!grid) { location.href = link.href; return; }
    const sectionId = results.getAttribute('section-id');
    const nextUrl = new URL(link.href);
    nextUrl.searchParams.set('section_id', sectionId);
    this.busy = true;
    link.setAttribute('aria-disabled', 'true');
    this.setAttribute('aria-busy', 'true');
    const status = this.querySelector('[role=status]');
    status.textContent = 'Producten laden...';
    try {
      const response = await fetch(nextUrl, { signal: this.controller.signal });
      if (!response.ok) throw new Error('Load failed');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = html.querySelector('.product-grid');
      if (!nextGrid) throw new Error('Missing products');
      const existing = new Set([...grid.querySelectorAll('[data-product-id]')].map(e => e.dataset.productId));
      const cards = [...nextGrid.querySelectorAll(':scope > li[data-product-id]')].filter(e => !existing.has(e.dataset.productId));
      grid.append(...cards);
      const nextLink = html.querySelector('smid-catalogue-more a[data-next-page]');
      if (nextLink) link.href = new URL(nextLink.getAttribute('href'), location.origin).href; else link.remove();
      status.textContent = `${cards.length} producten toegevoegd`;
      const firstLink = cards[0]?.querySelector('a');
      firstLink?.focus({ preventScroll: true });
    } catch (error) {
      if (error.name !== 'AbortError') status.textContent = 'Laden lukt niet. Probeer opnieuw of open de volgende pagina.';
    } finally {
      this.busy = false;
      this.removeAttribute('aria-busy');
      link.removeAttribute('aria-disabled');
    }
  }
}
if (!customElements.get('smid-catalogue-faq')) customElements.define('smid-catalogue-faq', SmidCatalogueFaq);
if (!customElements.get('smid-catalogue-more')) customElements.define('smid-catalogue-more', SmidCatalogueMore);
